import { useEffect } from 'react';

interface StructuredDataProps {
  data: Record<string, unknown>;
}

export default function StructuredData({ data }: StructuredDataProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [data]);

  return null;
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料718',
    url: 'http://qinglianhb.cn/',
    logo: 'http://qinglianhb.cn/logo.png',
    description: '黑料718官网——一站式吃瓜爆料平台，提供最新娱乐圈八卦、网红爆料、社会热点资讯及黑料718最新地址入口。',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '望京SOHO T3-B座 2806室',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-718-0001',
      contactType: 'customer service',
    },
    sameAs: ['http://qinglianhb.cn/'],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料718',
    url: 'http://qinglianhb.cn/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://qinglianhb.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: url,
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料718',
      url: 'http://qinglianhb.cn/',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(article: {
  title: string;
  description: string;
  url: string;
  image: string;
  datePublished: string;
  dateModified: string;
  author: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    url: article.url,
    image: article.image,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '黑料718',
      url: 'http://qinglianhb.cn/',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': article.url,
    },
  };
}

export function getFAQSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料718是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料718是一个专注于娱乐圈八卦、网红爆料和社会热点资讯的吃瓜爆料平台，每日更新最新爆料内容，为用户提供真实、快速、全面的娱乐资讯服务。',
        },
      },
      {
        '@type': 'Question',
        name: '如何下载黑料718 APP？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过黑料718官网（heiliao718.com）的APP下载专区获取最新版本的安卓和iOS客户端安装包，支持在线更新，确保您随时获取最新吃瓜内容。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料718的内容更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料718平台保持7×24小时不间断更新，每日更新不少于50条爆料资讯。重大娱乐事件发生时，我们会在第一时间进行追踪报道，确保用户不错过任何精彩内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何找到黑料718的最新地址？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料718的官方域名为heiliao718.com，建议您收藏官网地址。如遇访问问题，可通过我们的官方微博、微信公众号获取最新入口地址信息。',
        },
      },
    ],
  };
}